import { render, staticRenderFns } from "./Products copy.vue?vue&type=template&id=1e095edb&"
import script from "./Products copy.vue?vue&type=script&lang=js&"
export * from "./Products copy.vue?vue&type=script&lang=js&"
import style0 from "./Products copy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports